<section>
    <div class="top-section">
        <h3>
            Track Shipments
        </h3>
    </div>
</section>
<section class="track-shipment-inner-grey">
    <!-- <section class="track-shipment-box">
        <form [formGroup]="trackingForm" (ngSubmit)="onTrack()">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-1"><label>ShippingLine</label></div>
                <div class="col-md-2">
                    <p-dropdown class="form-control" [options]="shippinglineslist" optionLabel="shippingLineName"
                        [readonly]="isReadonly == true" formControlName="shippingLine" placeholder="Select ShippingLine"
                        [virtualScroll]="true" [filter]="false" class="p-dropdown"
                        (onChange)="getVesselsbyShipsId($event)">
                    </p-dropdown>
                </div>
                <div class="col-md-1">
                    <div class="label-right">
                        <label>Vessals</label>
                    </div>
                </div>
                <div class="col-md-2">
                    <p-dropdown class="form-control" [options]="vesselslist" optionLabel="vesselsName"
                        [readonly]="isReadonly == true" formControlName="vessel" placeholder="Select Vessel"
                        [virtualScroll]="true" [filter]="false" class="p-dropdown"
                        (onChange)="getVoyagesByVesselId($event)">
                    </p-dropdown>
                </div>
                <div class="col-md-1" *ngIf="isShown == false">
                    <div class="label-right">
                        <label>Voyage</label>
                    </div>
                </div>
                <div class="col-md-2" *ngIf="isShown == false">
                    <p-dropdown class="form-control" [options]="voyagelist" optionLabel="voyageName"
                        formControlName="Voyage" placeholder="Select Voyage" [virtualScroll]="true" [filter]="false"
                        class="p-dropdown">
                    </p-dropdown>
                </div>
                <div class="col-md-2" *ngIf="isShown == false">
                    <button class="btn btn-signIn">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path
                                d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                            <path d="M0 0h24v24H0z" fill="none" />
                        </svg>
                        Track</button>
                </div>
            </div>
        </form>
    </section> -->
</section>

<div class="trackingpage mt-5 mb-5" *ngIf="isFound == true">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="whitebox">
                    <div class="table-responsive">
                        <table class="table table-borderless">
                            <tr>
                                <td>
                                    <strong>Tracking number:</strong>
                                    <br /> {{trackNumber}}
                                </td>
                                <td>
                                    <strong>Share tracking number:</strong>
                                    <br /><a
                                        href="mailto:?subject=Take a look at this shipment&body=Take a look at this ship tracking {{windowUrl}}"><i
                                            class="fa fa-share"></i> Share</a>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Vessel name:</strong>
                                    <br /> {{vesselsname}}
                                </td>
                                <td>
                                    <strong>Shipping line</strong>
                                    <br /> {{shippingLineName}}
                                </td>
                            </tr>
                            <!--  <tr>
                                <td>
                                    <strong>Departure port:</strong>
                                    <br /> {{deptPortname}}
                                </td>
                                <td>
                                    <strong>Arrival port:</strong>
                                    <br />{{arrPortName}}
                                </td>
                            </tr> -->
                            <tr>
                                <td>
                                    <strong>Expected departure:</strong>
                                    <br />{{ExpectedDeparture}}
                                </td>
                                <td>
                                    <strong>Expected Arrival:</strong>
                                    <br />{{ExpectedArrival}}
                                </td>
                            </tr>
                        </table>
                        <button *ngIf="isViewPage == false" type="submit" class="btn btn-signIn track-right"
                            (click)="saveTracking()">Save
                            Tracking</button>
                    </div>
                </div>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 prelative">
                <div class="whitebox">
                    <!-- <img src="../../../../assets/images/map-with-ship.jpg" width="100%" alt=""> -->
                    <!-- <img  src="../../../assets/images/roro-ship-icon-60.png" alt=""> -->
                        <google-map class="agm-map" [zoom]="zoom" [center]="marker.position">
                            <map-marker  [options]="markerOptions" [position]="marker.position">
                            </map-marker>
                        </google-map>

                    <div *ngIf="isViewPage == true">
                        <div class="mapaddress1" *ngIf="isSource != true">
                            <strong>
                                {{currentLocation}} <br /> Next port: {{nextPortName}}<br /> ETA:
                                {{nextPortETA|date : 'dd/MM/yyyy'}} {{nextPortETA | date:'shortTime'}}<br />
                                Status:{{currentStatus}}
                            </strong>
                        </div>
                        <div class="mapaddress1" *ngIf="isSource == true && currentStatus == 'moored'">
                            <strong>
                                {{currentLocation}} <br /> Next port: {{nextPortName}}<br /> ETA:
                                {{ExpectedDeparture}} {{ExpectedDeparture | date:'shortTime'}}<br />
                                Status:{{currentStatus}}
                            </strong>
                        </div>
                    </div>
                    <div *ngIf="isViewPage != true">
                        <div class="mapaddress" *ngIf="isSource != true">
                            <strong>
                                {{currentLocation}} <br /> Next port: {{nextPortName}}<br /> ETA:
                                {{nextPortETA|date : 'dd/MM/yyyy'}} {{nextPortETA | date:'shortTime'}}<br />
                                Status:{{currentStatus}}
                            </strong>
                        </div>
                        <div class="mapaddress" *ngIf="isSource == true && currentStatus == 'moored'">
                            <strong>
                                {{currentLocation}} <br /> Next port: {{nextPortName}}<br /> ETA:
                                {{ExpectedDeparture}} {{ExpectedDeparture | date:'shortTime'}}<br />
                                Status:{{currentStatus}}
                            </strong>
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <div class="trackprogress mt-5">
            <!-- <img src="../../../assets/images/sea-ship-with-containers-35.png" alt=""> -->
            <div class="table-responsive">
                <table class="table table-borderless">
                    <tr>
                        <td width="100">Planned</td>
                        <td>
                            <div class="tp-ports">
                                <div>
                                    <!-- <strong>Departure port</strong><br />{{fromPlanArrivalDate}} -->
                                    <strong>{{deptPortname}}</strong><br />{{fromPlanArrivalDate}}
                                </div>
                                <div *ngFor="let item of trackingData">
                                    <div [ngStyle]="{'width':progressValues + 'px' }">
                                        {{item.toPortName}}<br /> {{item.toPlanArrivalDate}}
                                        <!-- {{dateConvert(item.toPlanArrivalDate)}} -->
                                    </div>
                                </div>
                                <div>
                                    <!-- <strong>Arrival port</strong><br />{{toPlanArrivalDate}} -->
                                    <strong>{{arrPortName}}</strong><br />{{toPlanArrivalDate}}

                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td style="position: relative;">
                            <!-- <img class="shipicon" [ngStyle]="{'left':progressData + '%' }"
                                src="../../../assets/images/sea-ship-with-containers-35.png" alt="">
                            <img class="shipicon" [ngStyle]="{'left':progressData -1 + '%' }"
                                src="../../../assets/images/roro-ship-icon.png" alt="">
                            <p-progressBar [value]="progressData"></p-progressBar>
                            <div class="bolderline"></div> -->
                        </td>
                    </tr>
                    <tr>
                        <td>Actual Progress</td>
                        <td>
                            <div class="tp-ports">
                                <div>
                                    <!-- <div *ngIf="isSource == true">Not departed {{deptPortname}} yet</div> -->
                                    <div *ngIf="isSource != true">ATD</div>
                                    <div *ngIf="isSource == true">ETD</div>
                                    {{ExpectedDeparture}}
                                </div>
                                <div *ngFor="let item of trackingData">
                                    <div *ngIf="item.isPortStatus == true" [ngStyle]="{'width':progressValues + 'px' }">
                                        <!-- {{dateConvert(item.toActualArrivalDate)}} -->
                                        <div *ngIf="item.isNextPort != true">ATD</div>
                                        <div *ngIf="item.isNextPort == true">ETA</div>
                                        {{item.toActualArrivalDate}}
                                    </div>
                                </div>
                                <div>
                                    <br />{{ExpectedArrival}}
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="whitebox mt-3 p-4">
            <div class="tptbox">
                <div *ngIf="delayed == 0">Status:
                    <strong>On Time</strong>
                </div>
                <div *ngIf="delayed > 0">Status:
                    <strong class="text-danger">Delayed {{delayed}} days</strong>
                </div>
                <div *ngIf="0 > delayed">Status:
                    <strong class="text-success">{{delayed}} days before</strong>
                </div>
                <div *ngIf="delayed == 0">Calculated arrival to {{arrPortName}}:
                    <strong>{{ExpectedArrival}}</strong>
                </div>
                <div *ngIf="delayed > 0">New calculated arrival to {{arrPortName}}:
                    <strong class="text-danger">{{ExpectedArrival}}</strong>
                </div>
                <div *ngIf="0 > delayed">New calculated arrival to {{arrPortName}}:
                    <strong class="text-success">{{ExpectedArrival}}</strong>
                </div>
            </div>
        </div>
    </div>
</div>